import { Close as CloseIcon } from "@material-ui/icons";
import { Dialog, IconButton, Paper } from "@material-ui/core";
import useStyles from "../../data/forms/forms-styles";
import { ImageType } from "./ImageEdit";
import ImageUpload from "./ImageUpload";
interface IProps {
	isOpen: boolean;
	onDiscardClick: () => any;
	setIsUserImagePresent: (state: boolean) => void;
	isUserImagePresent: boolean | undefined;
}

const AvatarUploadDialog = ({ isOpen, onDiscardClick, setIsUserImagePresent, isUserImagePresent }: IProps) => {
	const classes = useStyles();

	return (
		<Dialog
			maxWidth="lg"
			open={isOpen}
			style={{ zIndex: 1200 }}
			BackdropProps={{ style: { backgroundColor: "rgba(28, 49, 69, 0.4)" } }}
		>
			<Paper elevation={0} className={classes.dialogWindow}>
				<IconButton onClick={onDiscardClick} className={classes.dialogClose}>
					<CloseIcon />
				</IconButton>
				<ImageUpload
					imageType={ImageType.AVATAR}
					isImagePresent={isUserImagePresent}
					setIsImagePresent={setIsUserImagePresent}
					onDiscardClick={onDiscardClick}
				/>
			</Paper>
		</Dialog>
	);
};

export default AvatarUploadDialog;
